"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault")["default"];
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.defaultOptions = exports.OptionDispatchContext = exports.OptionContext = void 0;
exports.reducerOption = reducerOption;
exports.useOptionStore = exports.useOptionDispatch = void 0;
var _objectSpread2 = _interopRequireDefault(require("@babel/runtime/helpers/objectSpread2"));
var _react = require("react");
var defaultOptions = exports.defaultOptions = {
  size: 6,
  smoothing: 0.46,
  thinning: 0.73,
  streamline: 0.5,
  easing: function easing(t) {
    return t;
  },
  start: {
    taper: 0,
    easing: function easing(t) {
      return t;
    },
    cap: true
  },
  end: {
    taper: 0,
    easing: function easing(t) {
      return t;
    },
    cap: true
  }
};
var OptionContext = exports.OptionContext = /*#__PURE__*/(0, _react.createContext)(defaultOptions);
var OptionDispatchContext = exports.OptionDispatchContext = /*#__PURE__*/(0, _react.createContext)(function () {});
function reducerOption(tasks, action) {
  return (0, _objectSpread2["default"])((0, _objectSpread2["default"])({}, tasks), action);
}
var useOptionStore = exports.useOptionStore = function useOptionStore() {
  return (0, _react.useContext)(OptionContext);
};
var useOptionDispatch = exports.useOptionDispatch = function useOptionDispatch() {
  return (0, _react.useContext)(OptionDispatchContext);
};